
import { Options, Vue } from "vue-class-component";
import { inject } from "@vue/runtime-core";
import CreditorInfo from "@/components/CreditorInfo.vue";
import { VouchersService, VOUCHER_SERVICE } from "@/services/vouchers-service";

@Options({
  components: {
    CreditorInfo,
  },
  props: {
    messages: {
      type: Array,
      require: true,
    },
  },
})
export default class MessageView extends Vue {
  creditorName!: string | undefined;
  creditorTaxId!: string;
  private voucherService!: VouchersService;

  beforeCreate(): void {
    const voucherService = inject<VouchersService>(VOUCHER_SERVICE);
    if (voucherService) {
      this.voucherService = voucherService as VouchersService;
      this.creditorName = this.voucherService.getCreditorName();
      this.creditorTaxId = this.voucherService.getCreditorTaxId();
    }
  }
}
